<div class="calendar-container" (click)="$event.stopPropagation()">
  <div class="date-header">{{headerName}}</div>

  <div class="calendar-card">
    <div class="calendar-wrapper" #startCalendarWrapper>
      <!-- Left Calendar -->
      <mat-calendar 
        #startCalendar
        class="leftcalender"
        [selected]="selectedStartDate"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [dateClass]="StartDateClass"
        [dateFilter]="StartDateFilter"
        [startAt]="startAtLeft"
        (selectedChange)="selectDate('start', $event)"
        (viewChanged)="onViewChanged('start', $event)"
      ></mat-calendar>
  
      <!-- Floating Div for Left Calendar -->
      <div *ngIf="showFloatingDivLeft" class="floating-div-left">
      </div>
    </div>
  
    <div class="calendar-wrapper" #endCalendarWrapper>
      <!-- Right Calendar -->
      <mat-calendar 
        #endCalendar
        class="rightcalender"
        [selected]="selectedEndDate"
        [minDate]="selectedStartDate || minDate"
        [maxDate]="(!compulsaryFilter && isRestriction == 'no') ? null : maxDate"
        [dateClass]="EndDateClass"
        [dateFilter]="EndDateFilter"
        [startAt]="startAtRight"
        (selectedChange)="selectDate('end', $event)"
        (viewChanged)="onViewChanged('end', $event)"
      ></mat-calendar>
  
      <!-- Floating Div for Right Calendar -->
      <div *ngIf="showFloatingDivRight" class="floating-div-right">
      </div>
    </div>
  </div>
  

  <div class="date-inputs">
    <div class="input-group">
      <span class="input-group-text">Start Date</span>
      <input type="text" style="height: 38px;width: 20px;font-size: 12px;" class="form-control" placeholder=" " [value]="selectedStartDate | date: 'MM.dd.yyyy'" readonly />
    </div>
    <div class="input-group">
      <span class="input-group-text">End Date</span>
      <input type="text" style="height: 38px;width: 20px;font-size: 12px;" class="form-control" placeholder=" " [value]="selectedEndDate | date: 'MM.dd.yyyy'" readonly />
    </div>
  </div>

  <div class="actions">
    <button matTooltip="Clear Selection" class="btn clear" (click)="clearDates()">
      Clear
    </button>
    <button matTooltip="Apply Selection" style="box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);" class="btn apply" (closed)="removeFloatingDivs()" cdkMenu [disabled]="!selectedStartDate || !selectedEndDate" (click)="applyDates()">
      Apply
    </button>
  </div>
</div>